import { jwtEnvAxios } from ".";

export function getAiNotebooksApi() {
  return jwtEnvAxios("ai-lab").get(`/notebook/detail`);
}

export function updateAiNotebookApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").put(`/notebook/${id}`, data);
}

export function createAiNotebookApi(data: any) {
  return jwtEnvAxios("ai-lab").post(`/notebook`, data);
}

export function deleteAiNotebookApi(notebookId: string) {
  return jwtEnvAxios("ai-lab").delete(`/notebook/${notebookId}?force`);
}

export function stopAiNotebookApi(id: string) {
  return jwtEnvAxios("ai-lab").put(`/notebook/${id}/stop`);
}

export function startAiNotebookApi(id: string) {
  return jwtEnvAxios("ai-lab").put(`/notebook/${id}/start`);
}

export function getAiNotebookEditorsApi() {
  return jwtEnvAxios("ai-lab").get(
    `/notebook/capabilities/editor?compatibleWithFramework`
  );
}

export function getAiNotebookFreamworkApi() {
  return jwtEnvAxios("ai-lab").get(
    `/notebook/capabilities/framework?compatibleWithEditor`
  );
}

export function getAiRegionsDataApi() {
  return jwtEnvAxios("ai-lab").get(`/capabilities/region`);
}

export function getAiResourceFlavorsApi(region: string) {
  return jwtEnvAxios("ai-lab").get(`/capabilities/region/${region}/flavor`);
}

//
export function getAiNotebookApi(id: string) {
  return jwtEnvAxios("ai-lab").get(`/notebook/${id}`);
}

export function aiNotebookSynchronizationApi(id: string, data: any) {
  return jwtEnvAxios("ai-lab").post(`/notebook/${id}/datasync`, data);
}
